"use client";

import { c as _c } from "react/compiler-runtime";
import { useCallback, useMemo } from "react";
import { usePathname, useRouter, useSearchParams } from "next/navigation";
const CONTRACT_PARAM = "xtdh_received_contract";
interface XtdhCollectionSelectionResult {
  readonly selectedContract: string | null;
  readonly handleCollectionSelect: (contract: string | null | undefined) => void;
  readonly clearSelection: () => void;
}
function normalizeContract(value: string | null): string | null {
  if (!value) {
    return null;
  }
  const trimmed = value.trim();
  if (!trimmed) {
    return null;
  }
  return trimmed.toLowerCase();
}
export function useXtdhCollectionSelection() {
  const $ = _c(16);
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  let t0;
  if ($[0] !== searchParams) {
    t0 = normalizeContract(searchParams?.get(CONTRACT_PARAM) ?? null);
    $[0] = searchParams;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const selectedContract = t0;
  let t1;
  if ($[2] !== pathname || $[3] !== router || $[4] !== searchParams) {
    t1 = nextContract => {
      if (!pathname) {
        return;
      }
      const params = new URLSearchParams(searchParams?.toString() ?? "");
      if (nextContract) {
        params.set(CONTRACT_PARAM, nextContract);
      } else {
        params.delete(CONTRACT_PARAM);
      }
      const query = params.toString();
      router.replace(query ? `${pathname}?${query}` : pathname, {
        scroll: false
      });
    };
    $[2] = pathname;
    $[3] = router;
    $[4] = searchParams;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const updateQueryParams = t1;
  let t2;
  if ($[6] !== selectedContract || $[7] !== updateQueryParams) {
    t2 = contract => {
      const normalized = normalizeContract(contract ?? null);
      if (!normalized) {
        return;
      }
      if (normalized === selectedContract) {
        return;
      }
      updateQueryParams(normalized);
    };
    $[6] = selectedContract;
    $[7] = updateQueryParams;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  const handleCollectionSelect = t2;
  let t3;
  if ($[9] !== selectedContract || $[10] !== updateQueryParams) {
    t3 = () => {
      if (!selectedContract) {
        return;
      }
      updateQueryParams(null);
    };
    $[9] = selectedContract;
    $[10] = updateQueryParams;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  const clearSelection = t3;
  let t4;
  if ($[12] !== clearSelection || $[13] !== handleCollectionSelect || $[14] !== selectedContract) {
    t4 = {
      selectedContract,
      handleCollectionSelect,
      clearSelection
    };
    $[12] = clearSelection;
    $[13] = handleCollectionSelect;
    $[14] = selectedContract;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  return t4;
}